import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { CategoryItem } from 'features/categories/types/categories.types'

type UseCreateCategoryMutationProps = {
	onSuccess: () => void
}

export const useCreateCategoryMutation = ({ onSuccess }: UseCreateCategoryMutationProps) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createCategory, isPending: createCategoryLoading } = useMutation({
		mutationFn: (data: Pick<CategoryItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.categories(''), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
			useToast({ type: 'success', message: t('New category created!') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createCategory,
		createCategoryLoading
	}
}
